import { render, staticRenderFns } from "./developing.vue?vue&type=template&id=17139175&scoped=true&"
var script = {}
import style0 from "./developing.vue?vue&type=style&index=0&id=17139175&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17139175",
  null
  
)

export default component.exports